import { db } from 'Utilities/config';

export const obtenerDatos = async (collectionPath) => {
    try {
        // CatalogoFlexoresTest
        const data = await db.collection(collectionPath).get();
        const arrayData = data.docs.map(doc => ({...doc.data()}));
        // console.log(arrayData)
        return (arrayData);
    } catch (error) {
        console.log(error);
    }
}

export const agregarDatos = async (item, collectionPath) => {
    try {
        await db.collection(collectionPath).doc(item.id).set(item);
        console.log("Agregado con éxito")
    } catch (error) {
        console.log(error);
    }
}

export const eliminar = async (id, collectionPath) => {
    try {
        await db.collection(collectionPath).doc(id).delete();
    } catch (error) {
        console.log(error);
    }
}

export const editar = async (item, collectionPath) => {
    // console.log(item, collectionPath)
    try {
        await db.collection(collectionPath).doc(item.id).update(item)
        console.log("Editado")
    } catch (error) {
        console.log(error)
    }    
}